import { NameInLegendOption } from 'ChartApp/ts/enums/chart-common.enum';
import { Frequency } from 'ChartApp/ts/enums/tech-chart-common.enum';
export const NAME_IN_LEGEND_OPTIONS = [
    {
        label: 'Security Name and Ticker',
        value: NameInLegendOption.nameAndTicker,
    },
    {
        label: 'Security Name Only',
        value: NameInLegendOption.name,
    },
    {
        label: 'Ticker Only',
        value: NameInLegendOption.ticker,
    },
];
export const FREQUENCY_OPTIONS = [
    {
        label: 'Daily',
        value: Frequency.DAILY,
        disabled: false,
    },
    {
        label: 'Weekly',
        value: Frequency.WEEKLY,
        disabled: false,
    },
    {
        label: 'Monthly',
        value: Frequency.MONTHLY,
        disabled: false,
    },
];
// chart type constants
export const CHART_INTERACTIVE_MODE = 'interactive';
export const CHART_PRESENTATION_MODE = 'presentation';
export const CHART_TYPE_OPTIONS = [CHART_INTERACTIVE_MODE, CHART_PRESENTATION_MODE];
export const CHART_TYPE_DEFAULT = CHART_TYPE_OPTIONS[0];
export const PARTNER_OPTION_DEFAULT = 'basic_2000';
export const PARTNER_OPTIONS = [
    {
        label: 'Small (650 px wide)',
        value: 'basic_650',
    },
    {
        label: 'Medium (850 px wide)',
        value: 'basic_850',
    },
    {
        label: 'Large (1200 px wide)',
        value: 'basic_1200',
    },
    {
        label: 'Very Large (2000 px wide)',
        value: PARTNER_OPTION_DEFAULT,
    },
];
export const PARTNER_OPTION_VALUES = PARTNER_OPTIONS.map((o) => o.value).concat(['']);
// Tooltip styles
export const TOOLTIP_STYLE_BAR = 'bar';
export const TOOLTIP_STYLE_BOX = 'box';
export const TOOLTIP_STYLE_SEGMENT = 'segment';
export const CHART_PERFORMANCE_DISCLOSURE = 'The performance data quoted presents past performance; past performance does not guarantee future results; ' +
    'the investment return and principal value of an investment will fluctuate; ' +
    'an investor’s shares, when redeemed, may be worth more or less than their original cost; ' +
    'current performance may be lower or higher than the performance data quoted. ' +
    'The most recent month end performance data can be accessed at https://go.ycharts.com/fund_contact_info.';
